var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "row--x-small"
  }, _vm._l(_vm.items, function (_ref) {
    var text = _ref.text,
      value = _ref.value,
      icon = _ref.icon,
      items = _ref.items;
    return _c('v-col', {
      key: value,
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('v-card', _vm._b({
      attrs: {
        "flat": ""
      }
    }, 'v-card', {
      loading: _vm.loading
    }, false), [_c('v-select', _vm._b({
      key: value,
      attrs: {
        "multiple": "",
        "placeholder": text,
        "prepend-inner-icon": icon,
        "hide-details": "",
        "outlined": "",
        "clearable": ""
      },
      on: {
        "change": _vm.push
      },
      scopedSlots: _vm._u([{
        key: "item",
        fn: function (_ref2) {
          var item = _ref2.item;
          return [_c('v-list-item', {
            on: {
              "click": function ($event) {
                return _vm.setFilter({
                  key: value,
                  value: item.value
                });
              }
            }
          }, [_c('v-list-item-icon', [_c('v-simple-checkbox', {
            attrs: {
              "value": _vm.query[value].includes(item.value),
              "color": "primary"
            },
            on: {
              "click": function ($event) {
                return _vm.setFilter({
                  key: value,
                  value: item.value
                });
              }
            }
          })], 1), _c('v-list-item-title', [_vm._v(" " + _vm._s(item.text) + " ")])], 1)];
        }
      }], null, true),
      model: {
        value: _vm.query[value],
        callback: function ($$v) {
          _vm.$set(_vm.query, value, $$v);
        },
        expression: "query[value]"
      }
    }, 'v-select', {
      items
    }, false))], 1)], 1);
  }), 1);

}
var staticRenderFns = []

export { render, staticRenderFns }